import gql from 'graphql-tag';

export default gql`
  mutation updateMobile(
    $mobile: String!
  ) {
    updateMobile(
      mobile: $mobile
    ) {
      statusCode
      message
    }
  }
`;
